import { useSetState } from "ahooks";
import { createModel } from "hox";

function useHox() {
  const [state, setState] = useSetState<any>({
    cityInfo: { name: "上海市", code: "310000" },
    curLocation: {},
    loading: false
  });

  const updateCity = (_cityInfo: any) =>
    setState({
      cityInfo: _cityInfo,
    });
  const updateCurLocation = (_curLocation: any) =>
    setState({
      curLocation: _curLocation,
    });
  const updateLoading = (bol: any) =>
  setState({
    loading: bol,
  });
  return {
    state,
    updateCity,
    updateCurLocation,
    updateLoading,
  };
}

export default createModel(useHox);
